'use strict';
import angular from 'angular';
angular.module('flowingly.runner.user.profile', ['flowingly.user.profile']);
